import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import logoUrl from '../../assets/logo.png';
import StarField from '../../components/StarField';

export const AdminLogin = () => {
  const { isAuthed, checking, login } = useAdminAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#050814] flex items-center justify-center text-[#F4F1EA]/60">
        Checking session...
      </div>
    );
  }
  if (isAuthed) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(password);
    } catch (e2) {
      const detail = e2.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-[#050814] flex items-center justify-center px-4 overflow-hidden">
      <StarField count={140} showMoon={false} shootingStars={false} />
      <Card
        data-testid="admin-login-card"
        className="relative z-10 w-full max-w-md bg-[#0B132B]/90 backdrop-blur-md border border-[#B8860B]/30 shadow-[0_0_60px_rgba(184,134,11,0.15)]"
      >
        <CardHeader className="text-center pb-2">
          <img
            src={logoUrl}
            alt="Creek Bottom Ranch"
            className="w-24 h-auto mx-auto mb-2 drop-shadow-[0_0_25px_rgba(212,175,55,0.3)]"
          />
          <CardTitle className="font-display text-3xl text-[#F4F1EA] mt-1">Admin Dashboard</CardTitle>
          <p className="text-xs text-[#D4AF37] uppercase tracking-[0.32em] mt-1">Creek Bottom Ranch</p>
        </CardHeader>
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="admin-password" className="text-[#F4F1EA]">Password</Label>
              <Input
                data-testid="admin-password-input"
                id="admin-password"
                type="password"
                autoFocus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 bg-[#050814] border-[#B8860B]/30 text-[#F4F1EA] focus-visible:ring-[#B8860B]"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="text-sm text-red-400">
                {error}
              </p>
            )}
            <Button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#B8860B] hover:bg-[#D4AF37] text-[#050814] font-semibold py-5 rounded-full shadow-[0_0_30px_rgba(184,134,11,0.35)] transition-all"
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
